import { useState, useCallback } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Background } from '@Components/designConstants';
import { WidgetContainer } from '@Components/WidgetContainer';
import { DagLambdaFetch } from '../../../utils/fetch-utils';
import { AdOpsToolProps } from '../adops-constants';

export const LinearIngestions = ({ utils }: AdOpsToolProps) => {
  const [activeAPICall, setActiveAPICall] = useState(false);
  const { setError } = utils;

  const [linearIngestionCompany, setLinearIngestionCompany] = useState('');
  const [linearIngestionStatus, setLinearIngestionStatus] = useState('');

  const startLinearIngestion = useCallback(async () => {
    try {
      setActiveAPICall(true);
      if (
        linearIngestionCompany.startsWith('warbyparker') ||
        linearIngestionCompany.startsWith('instacart')
      ) {
        setLinearIngestionStatus(`Manual start of linear ingestions for ${linearIngestionCompany} are disabled. \n
        If restart is necessary, contact engineering team.`);
      } else {
        await DagLambdaFetch('/start', {
          method: 'POST',
          body: JSON.stringify({
            dag: linearIngestionCompany,
            start_task: 'WAITBVS',
            override: true,
            retries: 0
          })
        });
        setLinearIngestionStatus(`Started for ${linearIngestionCompany}`);
      }
    } catch (e) {
      setError({
        message: `Failed to start dag ${linearIngestionCompany}`,
        reportError: e
      });
    }
    setActiveAPICall(false);
  }, [linearIngestionCompany, setLinearIngestionStatus, setError]);

  return (
    <WidgetContainer
      className='linear-tool-card'
      header='Start Linear Ingestions'
      background={Background.DARK}
      dataTestId='linear-ingestions'
    >
      <InputGroup className='ad-ops-elem'>
        <InputGroup.Text className='input-label'>Company</InputGroup.Text>
        <Form.Control
          data-testid='linear-ingestion-company'
          value={linearIngestionCompany}
          onChange={e => setLinearIngestionCompany(e.target.value)}
        />
      </InputGroup>
      <div className='ad-ops-elem'>{linearIngestionStatus}</div>
      <Button
        className='ad-ops-elem'
        data-testid='linear-ingestion-start'
        loading={activeAPICall}
        onClick={startLinearIngestion}
      >
        Start
      </Button>
    </WidgetContainer>
  );
};
